module.exports = __webpack_public_path__ + "img/dj-utd.43f3ab89.jpeg";